<div class="tree-container">
	@for (boxGroup of boxGroups; track boxGroup) {
		<app-box-group-tree-item
			[boxGroup]="boxGroup"
			(itemDisplayed)="onBoxDisplayed($event)"
			(itemEdited)="onBoxEdited($event)"
			(itemDeleted)="onBoxDeleted($event)"
			(itemDuplicated)="onBoxDuplicated($event)"
			[expanded]="true"></app-box-group-tree-item>
	}
</div>
